import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import Popup from 'apps/promo/components/common/Popup/Popup';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import PromoSpinner from 'apps/promo/components/common/promo-spinner/PromoSpinner';
import { CardsSection } from 'apps/promo/components/common/sections/CardsSection';
import FaqSection from 'apps/promo/components/common/sections/FaqSection';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import TrustpilotSection from 'apps/promo/components/common/sections/TrustpilotSection';
import Footer from 'apps/promo/components/footer/Footer';
import HeaderFixed from 'apps/promo/components/header-fixed/HeaderFixed';
import BanksSection from 'apps/promo/components/landing/BanksSection';
import GeoSection from 'apps/promo/components/landing/GeoSection';
import HeroCalculatorSection from 'apps/promo/components/landing/HeroCalculatorSection';
import { useGetQueryParams } from 'apps/promo/components/utils';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';
import MessageBodyService from 'apps/promo/components/utils/MessageBodyService';
import { useMatchMedia } from 'apps/promo/hooks/useMatchMedia';
import promoBreakpoints from 'apps/promo/theme/promoBreakpoints';

import styles from './LandingNewPage.module.css';

const LandingNewPage = (props) => {
    const isTablet = useMatchMedia(promoBreakpoints.tablet744);

    const lang = props.lang ? props.lang : 'en';
    const country = props.country ? props.country : 'gb';

    const renderOptions = props.renderOptions;

    const urlParams = useGetQueryParams();

    useEffect(() => {
        const link = document.querySelector('link[rel="preload"]');
        if (link) {
            link.rel = 'stylesheet';
        }
    }, []);

    const showHeader =
        !props.loading && !renderOptions?.isHelpMobile && !renderOptions?.hideHeader && Array.isArray(props.newMenuObject) && props.newMenuObject.length > 0;

    return (
        <>
            <div id="modal-root" />
            {showHeader && (
                <HeaderFixed
                    loading={props.loading}
                    isShowNavModal={props.isShowNavModal}
                    menuSection={props.stateOptions?.menuSection}
                    data={props.newMenuObject}
                    pageName={props.stateOptions?.pageName}
                    promoDarkPage={renderOptions?.promoDarkPage}
                    libre={renderOptions?.isLibre}
                    hasChatButton={renderOptions?.hasChatButton}
                    isBlogPage={props.stateOptions?.section === 'blog'}
                    isLanding={true}
                />
            )}
            <PromoPageContainer bgColor="eggshell03">
                <HeroCalculatorSection />
                <ColoredSectionContainer>
                    {props.downloadAppBlockTitle && props.downloadAppBlockSubtitle && (
                        <HeadingSection title={props.downloadAppBlockTitle} text={props.downloadAppBlockSubtitle} hasAppsBtns noBottomIndent />
                    )}
                    {!props.isRequest && <BanksSection />}
                    {(props.headlineBenefitsTitle || props.headlineBenefitsText) && (
                        <HeadingSection title={props.headlineBenefitsTitle} text={props.headlineBenefitsText} />
                    )}

                    {props.benefitsBlock && props.benefitsBlock.length > 0 && (
                        <TilesSection lang={lang} country={country} data={props.benefitsBlock} grayText loadingLazy />
                    )}

                    {!props.isRequest && props.deliveryMethods && (
                        <div className={styles.cardsSectionWrapper}>
                            <CardsSection data={props.deliveryMethods} titleGradient="aubergine01" variant="contentRow" />
                        </div>
                    )}

                    {props.benefitsBlock2 && props.benefitsBlock2.length > 0 && (
                        <TilesSection lang={lang} country={country} data={props.benefitsBlock2} grayText loadingLazy />
                    )}

                    {isTablet && <GeoSection />}

                    <TrustpilotSection lang={lang} />
                </ColoredSectionContainer>
                {props.crossProductsBlock && (
                    <ColoredSectionContainer>
                        <TilesSection lang={lang} country={country} data={props.crossProductsBlock} />
                    </ColoredSectionContainer>
                )}

                {props.questions && <FaqSection title={props.faqTitle} questions={props.questions} />}
            </PromoPageContainer>
            <PromoSpinner />
            {props.noAuthFooter && (
                <Footer
                    data={props.noAuthFooter}
                    lang={lang}
                    country={country}
                    isLanding={true}
                    isRequest={props.isRequest}
                    c3p0={urlParams.version === 'c3p0'}
                />
            )}
            <MessageBodyService />
            <Popup />
            {props.isShowModal && props.modalComponent}
        </>
    );
};

const mapStateToProps = ({ app, extra }) => {
    return {
        noAuthFooter: extra.noAuthFooter,
        isShowPopup: app.isShowPopup,
        isShowNavModal: app.isShowNavModal,
        isShowModal: app.isShowModal,
        modalComponent: app.modalComponent,
        lang: extra.noAuthFooter?.language?.lang,
        country: extra.noAuthFooter?.language?.country,
        extra: extra,
        notFound: extra.notFound,
        newMenuObject: extra.newNoAuthMenu?.header,

        headlineBenefitsTitle: extra?.strapiApi?.headlineBenefits?.title,
        headlineBenefitsText: extra?.strapiApi?.headlineBenefits?.text,

        benefitsBlock: extra?.strapiApi?.benefitsBlock,

        deliveryMethods: extra?.strapiApi?.calculator?.deliveryMethods,

        benefitsBlock2: extra?.strapiApi?.benefitsBlock2,

        downloadAppBlockTitle: extra?.strapiApi?.downloadAppBlock?.title,
        downloadAppBlockSubtitle: extra?.strapiApi?.downloadAppBlock?.text,

        crossProductsBlock: extra?.strapiApi?.crossProductBlock,

        faqTitle: extra?.strapiApi?.faq?.title,
        questions: extra?.strapiApi?.faq?.questions,

        isRequest: extra?.strapiApi?.calculator?.operation === 'request',
    };
};

export default connect(mapStateToProps, null)(BasePageForNoAuth(LandingNewPage));
